import translate from '@/services/translate';

const OSCILLOGRAPHY_ANALYSIS_SINGULAR = 'Análise de Oscilografia';

export default function getModuleDisplayName(name) {
  if (name === OSCILLOGRAPHY_ANALYSIS_SINGULAR) {
    return translate('enums.engineering.oscillography-analysis.name');
  }

  return name;
}
